var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#707070",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 79.935 79.935",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil0 {fill:#707070;fill-rule:nonzero}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M54.073 9.405c-2.597,0 -4.703,-2.106 -4.703,-4.703 0,-2.596 2.106,-4.702 4.703,-4.702l21.16 0c2.595,0 4.702,2.108 4.702,4.702l0 21.161c0,2.596 -2.106,4.702 -4.702,4.702 -2.596,0 -4.702,-2.106 -4.702,-4.702l0 -9.81 -27.239 27.239c-1.836,1.835 -4.813,1.835 -6.649,0 -1.835,-1.836 -1.835,-4.813 0,-6.649l27.239 -27.238 -9.809 0zm16.458 35.265c0,-2.597 2.106,-4.702 4.702,-4.702 2.596,0 4.702,2.105 4.702,4.702l0 30.563c0,2.596 -2.106,4.702 -4.702,4.702l-70.531 0c-2.596,0 -4.702,-2.106 -4.702,-4.702l0 -70.531c0,-2.596 2.106,-4.702 4.702,-4.702l30.563 0c2.597,0 4.703,2.106 4.703,4.702 0,2.597 -2.106,4.703 -4.703,4.703l-25.86 0 0 61.126 61.126 0 0 -25.861z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a0d5da13a2aa1d3a67339d1675dfbc63.svg";
export { ForwardRef as ReactComponent };